<template>
  <div class="text-options-setting-dialog">
    <div class="content-group-default">
      <el-collapse v-model="activeNames" style="width: 100%">
        <controlWidthAndSizeAndZindex :options="options" :ids="ids" />
        <el-collapse-item @mousedown.native="collapseMouseDown($event, '5')" title="数据设置" name="5">
          <slider-and-input
            class="mb16"
            :value.sync="maxCount"
            title="最大条数"
            :sliderMax="50"
            :sliderMin="10"
            suffix="条"
          />
        </el-collapse-item>
        <chart-common-options-setting-1 :options="options" :ids="ids"></chart-common-options-setting-1>
        <el-collapse-item @mousedown.native="collapseMouseDown($event, '2')" title="数据样式" name="2">
          <div class="mb8">文字样式</div>
          <!-- 字体和颜色/字重和字号 -->
          <div class="simple">
            <div class="verticallyCenter mb16">
              <el-select
                :style="{ height: '32px', width: '100%', '--fontFamily': fontFamily }"
                popper-class="font-families"
                class="font-family-select"
                v-model="fontFamily">
                <el-option v-for="(item, index) in fontFamilyList" :key="index" :label="item.title" :value="item.value">
                  <img :src="item.img" class="font-family-img" />
                </el-option>
              </el-select>
            </div>
            <!-- 字体 -->
            <div class="content mb16 verticallyCenter">
              <div class="content-item mr8">
                <el-select v-model="fontWeight" class="height32" style="width: 126px" ref="">
                  <el-option
                    v-for="(item, index) in currentFontWeightList"
                    :key="index"
                    :selected="fontWeight == item.value"
                    :value="item.value"
                    :label="item.title"
                  >
                  </el-option>
<!--                  <el-option-->
<!--                    v-for="(item, index) in fontWeightList"-->
<!--                    :key="index"-->
<!--                    :selected="fontWeight == item.value"-->
<!--                    :value="item.value"-->
<!--                    :label="item.title"-->
<!--                    >{{ item.title }}-->
<!--                  </el-option>-->
                </el-select>
              </div>
              <div class="content-item flex1">
                <div class="font-arrangement-btn multiple">
                  <span
                    v-for="(item, index) in fontStyleList"
                    :key="index"
                    :class="item.isActive ? 'select pd1' : 'pd1'"
                    @click="changeStyle(index, item.isActive, '')"
                    ><i :class="item._class"></i
                  ></span>
                </div>
              </div>
            </div>
            <!--字重和字号 -->
          </div>
          <div class="setting-item clearFloat mb16">
            <div class="content">
              <div class="content-item floatLeft mr8">
                <el-input
                  style="width: 110px"
                  v-inputHandle="{ this1, type: 'minFontSize' }"
                  type="number"
                  v-model="minFontSize"
                  placeholder="请输入"
                >
                  <template slot="suffix">
                    <span class="suffix_text">px</span>
                  </template>
                </el-input>
                <p class="fs12 mt8">字号最小值</p>
              </div>
              <div class="content-item floatLeft">
                <el-input
                  v-inputHandle="{ this1, type: 'maxFontSize' }"
                  type="number"
                  style="width: 110px"
                  v-model="maxFontSize"
                  placeholder="请输入"
                >
                  <template slot="suffix">
                    <span class="suffix_text">px</span>
                  </template>
                </el-input>
                <p class="fs12 mt8">字号最大值</p>
              </div>
            </div>
          </div>
          <!-- 特殊背景色 -->
          <div class="mt16">
            <label class="font14 inlineMiddle mr24"
              >数据颜色<span @click="addColorControl" class="icon-portal-plus-small right_font"
            /></label>
            <div
              class="verticallyCenter mt16 single_color"
              v-for="(color, index) in colorList"
              :key="index"
              @dragover.prevent
              @drop="stopChangePosition(color, index, $event)"
            >
              <color-picker class="w_196 mt-0" :color="color" @change="changeColor(color, index, $event)" />
              <div class="icon_set inlineMiddle" @click="deleteColor(index)">
                <span class="fs16 icon-portal-delete" />
              </div>
              <div class="icon_set icon_move inlineMiddle">
                <img
                  v-if="request_prefix === 'bigScreen'"
                  :src="Vector"
                  draggable="true"
                  @dragstart="startChangePosition(color, index, $event)"
                />
                <img v-else :src="homeVector" draggable="true" @dragstart="startChangePosition(color, index, $event)" />
              </div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item
          @mousedown.native="collapseMouseDown($event, '4')"
          :title="request_prefix === 'bigScreen' ? '动画设置' : '旋转效果'"
          name="4"
        >
          <div class="setting-item mb16">
            <ul class="animate-types" :class="request_prefix !== 'bigScreen' ? 'custom_style_2' : ''">
              <li
                v-for="(animate, index) in animateTypes"
                :class="isAnimate == animate.animateStatu ? 'active' : ''"
                @click="changeAnimateType(animate.animateStatu)"
                :key="index"
              >
                <div class="animate-icon-box">
                  <span class="animate-icon" :class="animate.animateIcon"></span>
                  <i v-if="isAnimate == animate.animateStatu" class="animate-selected"></i>
                </div>
                <p>{{ animate.label }}</p>
              </li>
            </ul>
          </div>
          <slider-and-input
            class="mb16"
            inputWidth="small"
            inputHeight="small"
            :value.sync="animateRotate"
            title="旋转角度"
            titlePosition="singleLine"
            :sliderMax="sliderMax"
            suffix="度"
          />
          <div class="verticallyCenter">
            <span class="option_name fs14 mr12" style="font-size: 14px;">旋转频率</span>
            <el-radio-group v-model="animateSpeed" >
              <el-radio :label="speed.speedBase" v-for="(speed, index) in animateSpeeds" :key="index">{{
                speed.title
              }}</el-radio>
            </el-radio-group>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import publicData from "toolbarComponents/bigScreen/common/options/publicData"
import Vector from "assets/images/Vector.png"
import homeVector from "assets/images/homeVector.png"
import controlWidthAndSizeAndZindex from "publicSetting/controlWidthAndSizeAndZindex.vue"
import TextSettingComplex from "modules/components/textSettingComplex"
import ChartCommonOptionsSetting1 from "toolbarComponents/bigScreen/common/chart-common-options-setting-1"
export default {
  mixins: [publicData],
  name: "text-options-data",
  components: {
    TextSettingComplex,
    controlWidthAndSizeAndZindex,
    ChartCommonOptionsSetting1,
    bigScreenAnimateSet: () => import("components/stageComponents/toolbar/bigScreen-animate-set.vue")
  },
  props: { options: Object },
  data() {
    return {
      Vector,
      homeVector,
      activeNames: ["1", "2", "3", "5"],
      hoverOpt: [],
      this1: this,
      collapseActiveNames: [],
      activeType: 1,
      sliderMax: 360,
      fontStyleList: [
        {
          _class: "icon-portal-text-bold1",
          isActive: false
        },
        {
          _class: "icon-portal-text-italic1",
          isActive: false
        },
        {
          _class: "icon-portal-text-underline1",
          isActive: false
        }
      ],
      hoverFontStyleList: [
        {
          _class: "icon-portal-text-bold1",
          isActive: false
        },
        {
          _class: "icon-portal-text-italic1",
          isActive: false
        },
        {
          _class: "icon-portal-text-underline1",
          isActive: false
        }
      ],
      arrangementList: [
        {
          label: "左对齐",
          className: "icon-portal-text-leftt1",
          value: "left"
        },
        {
          label: "右对齐",
          className: "icon-portal-text-right1",
          value: "right"
        },
        {
          label: "居中对齐",
          className: "icon-portal-text-center1",
          value: "center"
        },
        {
          label: "两端对齐",
          className: "icon-portal-text-both1",
          value: "justify"
        }
      ],
      animateTypes: [
        {
          label: "无效果",
          animateStatu: false,
          animateIcon: "animate-no"
        },
        {
          label: "旋转",
          animateStatu: true,
          animateIcon: "animate-overturn"
        }
      ],
      animateSpeeds: [
        {
          title: "快",
          speedBase: 100 //数越小速度越快，
        },
        {
          title: "中",
          speedBase: 600 //数越小速度越快，
        },
        {
          title: "慢",
          speedBase: 1200 //数越小速度越快，
        }
      ]
    }
  },
  comments: {},
  created() {},
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    fontWeightMap() {
      const fontWeightMap = this.fontFamilyList.reduce((total, now) => {
        const { value, fontWeightList } = now
        total[value] = fontWeightList
        return total
      }, {})
      return fontWeightMap
    },
    currentFontWeightList() {
      return this.fontWeightMap[this.fontFamily] || this.fontWeightList
    },
    content: {
      get() {
        return this.options.content
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "content", false)
      }
    },
    maxCount:{
      get() {
        // 兼容旧数据，以前么有设置的调整为50
        return this.checkAndSetPrimaryVal(this.options, "maxCount", "maxCount", 50)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "maxCount", false)
      }
    },
    contentHasLimit: {
      get() {
        return this.options.contentHasLimit
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "contentHasLimit", false)
      }
    },
    textLimitLines: {
      get() {
        return this.options.textLimitLines
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textLimitLines", false)
      }
    },
    noCacheComponent: {
      get() {
        return this.options && this.options.noCacheComponent ? this.options.noCacheComponent : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "noCacheComponent", false)
      }
    },
    activeRect() {
      // this.options();
      let ids = this.$store.state.states.activeID
      if (ids !== null) {
        this.container_id = ids.container_id
        this.rect_id = ids.rect_id
        return this.$store.state.states.activeID
      } else return null
    },
    activeArrangement() {
      return this.options.textAlign
    },
    rotate: {
      get() {
        return parseInt(this.options.rotate)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal + "deg", "rotate", false)
      }
    },
    animateRotate: {
      get() {
        return parseInt(this.options.animateRotate)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal + "deg", "animateRotate", false)
      }
    },
    isAnimate: {
      get() {
        return this.options.isAnimate
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "isAnimate", false)
      }
    },
    animateSpeed: {
      get() {
        return this.options.animateSpeed
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "animateSpeed", false)
      }
    },
    fontFamily: {
      get() {
        return this.options.fontFamily
      },
      set(newVal) {
        const currentWeightList = this.fontWeightMap[newVal]
        if (currentWeightList?.length && !currentWeightList.some(item => item.value === this.fontWeight)) {
          this.fontWeight = currentWeightList[0].value
        }
        this.$changeOptionsEV(newVal, "fontFamily", false)
      }
    },
    fontSize: {
      get() {
        return this.options.fontSize
      },
      set(newVal) {
        this.lineHeight = newVal > this.lineHeight ? newVal : this.lineHeight
        this.$changeOptionsEV(newVal, "fontSize", false)
      }
    },
    fontWeight: {
      get() {
        return this.options.fontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontWeight", false)
      }
    },
    color: {
      get() {
        return this.options.color
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "color", false)
      }
    },
    colorType: {
      get() {
        return this.options.colorType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "colorType", false)
      }
    },
    startColor: {
      get() {
        return this.options.startColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "startColor", false)
      }
    },
    endColor: {
      get() {
        return this.options.endColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "endColor", false)
      }
    },
    bgColor: {
      get() {
        return this.options.bgColor || "#fff"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgColor", false)
      }
    },
    textAlign: {
      get() {
        return this.options.textAlign
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textAlign", false)
      }
    },
    fontStyle: {
      get() {
        return this.options.fontStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontStyle", false)
      }
    },
    lineHeight: {
      get() {
        return this.options.lineHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lineHeight", false)
      }
    },
    letterSpacing: {
      get() {
        return this.options.letterSpacing
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "letterSpacing", false)
      }
    },
    activeArrangementOrder: {
      get() {
        return {
          _class: "icon-portal-text-down1",
          isActive: this.options.writingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.$changeOptionsEV(val, "writingMode", false)
      }
    },
    writingMode: {
      get() {
        return this.options.writingMode
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "writingMode", false)
      }
    },
    textDecoration: {
      get() {
        return this.options.textDecoration
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textDecoration", false)
      }
    },
    opacity: {
      get() {
        return this.options.opacity
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "opacity", false)
      }
    },
    minFontSize: {
      get() {
        return this.options.minFontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "minFontSize", false)
        if(parseInt(newVal) > parseInt(this.maxFontSize)){
          this.maxFontSize = parseInt(newVal)
        }
      }
    },
    maxFontSize: {
      get() {
        return this.options.maxFontSize
      },
      set(newVal) {
        if (newVal < this.minFontSize) {
          newVal = this.minFontSize
        }
        this.$changeOptionsEV(parseInt(newVal), "maxFontSize", false)
      }
    },
    colorList: {
      get() {
        return this.options.colorList || []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "colorList", false)
      }
    }
  },
  methods: {
    switchHandle(type) {
      this.activeType = type
    },
    changeStyle(flag, temp, hoverFlag) {
      let curFontStyleList = hoverFlag ? "hoverFontStyleList" : "fontStyleList"
      switch (flag) {
        case 0:
          let fontWeightName = hoverFlag ? hoverFlag + "FontWeight" : "fontWeight"
          if (temp) {
            this[curFontStyleList][flag].isActive = false
            this[fontWeightName] = 400
          } else {
            this[curFontStyleList][flag].isActive = true
            this[fontWeightName] = 500
          }
          break
        case 1:
          let fontStyleName = hoverFlag ? hoverFlag + "FontStyle" : "fontStyle"
          if (temp) {
            this[curFontStyleList][flag].isActive = false
            this[fontStyleName] = "normal"
          } else {
            this[curFontStyleList][flag].isActive = true
            this[fontStyleName] = "italic"
          }
          break
        case 2:
          let textDecorationName = hoverFlag ? hoverFlag + "TextDecoration" : "textDecoration"
          if (temp) {
            this[curFontStyleList][flag].isActive = false
            this[textDecorationName] = "none"
          } else {
            this[curFontStyleList][flag].isActive = true
            this[textDecorationName] = "underline"
          }
          break
      }
    },
    changeArrangement(val, hoverFlag) {
      let cutTextAlign = hoverFlag ? hoverFlag + "TextAlign" : "textAlign"
      this[cutTextAlign] = val.value
    },
    changeArrangementOrder(flag, hoverFlag) {
      let curActiveArrangementOrder = hoverFlag ? hoverFlag + "ActiveArrangementOrder" : "activeArrangementOrder"
      let curWritingMode = hoverFlag ? hoverFlag + "WritingMode" : "writingMode"

      if (flag) {
        this[curActiveArrangementOrder].isActive = false
        // this[curWritingMode] = "horizontal-tb"
        this.$changeOptionsEV("horizontal-tb", curWritingMode, false)
      } else {
        this[curActiveArrangementOrder].isActive = true
        // this[curWritingMode] = "vertical-lr"
        this.$changeOptionsEV("vertical-lr", curWritingMode, false)
      }
    },
    addColorControl() {
      this.request_prefix === "bigScreen" ? this.colorList.push("#FFFFFF") : this.colorList.push("#3D82F2")
    },
    deleteColor(index) {
      this.colorList.splice(index, 1)
    },
    changeColor(color, index, newColor) {
      this.$set(this.colorList, index, newColor)
    },
    stopChangePosition(color, index, e) {
      const dragColor = JSON.parse(e.dataTransfer.getData("dragRank"))
      this.$set(this.colorList, dragColor.index, color)
      this.$set(this.colorList, index, dragColor.color)
    },
    startChangePosition(color, index, e) {
      e.dataTransfer.setData("dragRank", JSON.stringify({ color, index }))
    },
    collapseMouseDown($event, val) {
      if ($event.target.classList[0] === "el-collapse-item__header") {
        const _index = this.collapseActiveNames.findIndex(it => it === val)
        _index === -1 ? this.collapseActiveNames.push(val) : ""
      }
    },
    changeAnimateType(animateStatu) {
      this.isAnimate = animateStatu
    }
  }
}
</script>

<style scoped lang="scss">
.w_196 {
  width: 196px;
}
.color-picker-container.custom-text-bg {
  width: calc(100% - 80px);
  display: inline-block;
  vertical-align: middle;
}
.paddingl0 {
  padding-left: 0;
}
::v-deep.el-input .el-input__inner {
  background-color: var(--inputBackGround);
}
.right_font {
  position: absolute;
  right: 29.5px;
  text-align: right;
  color: var(--themeColor);
}
.right_font:hover {
  cursor: pointer;
}
.single_color .icon_set {
  font-size: 14px;
  color: var(--thirdTextColor);
  line-height: 1;
  cursor: pointer;
  margin-left: 4px;
}
.single_color .icon_set.icon_move {
  cursor: move;
  margin-left: 14px;
}
.animate-types {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
}

.animate-types > li {
  text-align: center;
  cursor: pointer;
  font-size: 12px;
}

.animate-icon-box {
  position: relative;
}

.animate-types > li:not(:nth-child(3n)) {
  margin-right: 36px;
}
.bigScreen-toolbar .animate-types > li:not(:nth-child(3n)) {
  margin-right: 21px;
}
.animate-types > li.active .animate-icon {
  /*outline: 2px solid var(--themeColor);*/
  box-shadow: 0 0 0 2px var(--themeColor) inset;
}

.animate-types .animate-icon {
  display: inline-block;
  width: 60px;
  height: 60px;
  border-radius: 4px;
  overflow: hidden;
  box-sizing: border-box;
  background-color: var(--inputBackGround);
  background-size: auto auto;
  background-position: center center;
  background-repeat: no-repeat;
}
.animate-overturn {
  background-image: url("../../../assets/images/animate_icon/overturn.png");
}
.animate-no {
  background-image: url("../../../assets/images/animate_icon/none.png");
}
.custom_style_2 > li .animate-icon {
  box-shadow: 0 0 0 1px #e9e9e9;
}
.custom_style_2 > li .animate-overturn,
.animate-types > li.active .animate-overturn {
  background-image: url("../../../assets/images/animate_icon/overturn_selected.png");
}
.custom_style_2 > li .animate-no,
.animate-types > li.active .animate-no {
  background-image: url("../../../assets/images/animate_icon/none_selected.png");
}
.animate-selected {
  position: absolute;
  display: inline-block;
  width: 24px;
  height: 24px;
  right: 0;
  top: 36px;
  z-index: 2;
  background: url("../../../assets/images/animate_icon.png") -5px -215px;
  background-size: 280px 244px;
}
.font-arrangement-btn.multiple span.select {
  background: var(--leftMenuBgColor);
}
.multiple span:first-child::after {
  display: none;
}
.multiple span:nth-child(2)::after {
  display: block;
}
.font-families .el-select-dropdown__item {
  padding: 0;
  overflow: hidden;
}
.font-family-img {
  display: inline-block;
  width: 174px;
  height: 38px;
  width: auto;
}
.el-select-dropdown.font-families {
  transform: translate(-10px, 0);
}
::v-deep .font-family-select .el-input__inner {
  font-family: var(--fontFamily);
}
</style>
